/**
 * The server's onboarding numbering. `TOTAL_STEPS` (6) means finished - it is
 * what `PATCH /api/brand/onboarding-step` records and what App.tsx gates on.
 * The flow lives on steps FIRST_STEP..LAST_SLIDE (invoice details, card, done);
 * steps 1 and 5 are retired. Deliberately NOT compacted: live rows are mid-flow.
 */
export const TOTAL_STEPS = 6;
export const FIRST_STEP = 2;
export const LAST_SLIDE = 4;
